module.exports = __webpack_public_path__ + "img/video_icon10.4d010656.png";